// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3sFzZ","rootSmall":"AddTileButton_rootSmall__Co1fR"};